export default {
  title: '{{plan}} jest aktywny',
  plan: 'Plan: {{plan}}',
  free_until: 'Bezpłatnie do {{date}}',
  continue: 'Dalej',
};
